"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n"])));

var StyledButtonWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1 1 50%;\n  width: 50%;\n  padding: 0 0.5rem 0 0;\n"])));

var ProfileHelp = function ProfileHelp(_ref) {
  var translations = _ref.translations;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_fiverReactUiComponents.Card, {
    padding: "0 1rem 1rem",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.CardTitle, {
      children: "Low6 Help"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
          id: "take-break-btn",
          isDefault: true,
          to: "/take-break",
          size: "sm",
          children: translations.takeABreak
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
          id: "self-exclusion-btn",
          isDefault: true,
          to: "/self-exclusion",
          size: "sm",
          children: translations.selfExclusion
        })
      })]
    })]
  });
};

var _default = ProfileHelp;
exports.default = _default;